import { createUploadLink } from 'apollo-upload-client'
import { BatchHttpLink } from 'apollo-link-batch-http'
import { fetchOptions } from 'src/services'
import { ApolloLink } from 'apollo-link'

/**
 * Defines the GraphQL Http endpoint.
 * If operation context has its field `upload` to true, then the Upload link will be used.
 * Otherwise, the BatchHttpLink will be used.
 *
 * @see https://github.com/jaydenseric/apollo-upload-client
 * @see https://github.com/apollographql/apollo-link/tree/master/packages/apollo-link-batch-http
 */
const options = { uri: '/graphql', ...fetchOptions }

export default ApolloLink.split(
  operation => operation.getContext().upload,
  createUploadLink(options),
  new BatchHttpLink(options)
)
